<template>
  <div class="main-view library-container">
		<div class="bg-container blog-hero ">
			<div class="template-inner flex-row">
				<div class="one-half">
					<img src="@/assets/img/fpo/featured-post-img.png" alt="" class="featured-post-img">
				</div>
				<div class="one-half">
					<span class="featured-post-info white">Books & Guides</span>
					<h2 class="featured-post-title white">Creating a Climate for Change</h2>
					<p class="featured-post-teaser white">Evergrow helps companies thrive by empowering their people to change the world. We’ve created a revolutionary AI-powered personalized employee engagement platform that recognizes employee’s best work with the world’s coolest rewards. Evergrow also helps work environments transform the global environment…</p>
					<button class="featured-library-post-cta inverted">read more</button>
				</div>
			</div>
		</div>

		<bg-wave-element></bg-wave-element>
		<div class="template-inner filter-container flex-row align-center justify-center">
			<button class="inverted">All</button>
			<button class="inverted">Books & Guides</button>
			<button class="inverted">Case Studies</button>
			<button class="inverted">Infographics</button>
			<button class="inverted">Videos</button>
		</div>

		<div class="template-inner blog-posts-container">
			<div class="flex-row">
				<div class="one-third">
					<p>post</p>
				</div>
				<div class="one-third">
					<p>post</p>
				</div>
				<div class="one-third">
					<p>post</p>
				</div>
			</div>

			<div class="flex-row">
				<div class="one-third">
					<p>post</p>
				</div>
				<div class="one-third">
					<p>post</p>
				</div>
				<div class="one-third">
					<p>post</p>
				</div>
			</div>
		</div>
		<Demo />
	</div>
</template>

<script>
	import Demo from "../components/Demo";

	export default {
		name: 'Resources-Library',
		components: {
			Demo
		}
	}
</script>

<style lang="stylus" scoped>
	.library-container 
		margin-top 117px

	.blog-hero
		background-color #00A562
		padding 100px 0 240px
	
	.featured-post-img
		width 100%
		
	.featured-library-post-cta
		border-color #fff
		color #fff
</style>